import ContentBox from '../ContentBox';

export default () => {
  return (
    <div style={{ height: "calc(95vh - 50px)" }}>
      <ContentBox style={{ height: "100%" }}>
        <iframe
          style={{
            width: "100%",
            height: "100%",
            border: "none",
            position: "sticky",
            top: "0px",
            userSelect: "none",
          }}
          src="https://www.idas.com.tr"
        >
          IFRAME DESTEKLENMIYOR
        </iframe>
      </ContentBox>
    </div>
  );
};
